











import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Empty } from "vant";
@Component({
  name: "notFound",
  components: {
    [Empty.name]: Empty,
  },
})
export default class NotFound extends Vue {
  //data
  notPage = require("../../static/img/notPage.png");
}
